// import {
// 	DateTimePicker,
// 	MuiPickersUtilsProvider,
// // } from '@material-ui/pickers';
import { Box, Grid } from "@mui/material";
import {
	getCommunityFavouritesGraph,
	getCurationShareGraph,
	getGrapeListGraph,
	getPlayoffShareGraph,
	getProductViewCount,
	getUserShareGraph,
} from "../apis/Api";

// import Link from "@mui/material/Link";
import CurationListGraphCard from "../components/Dashboard/GrapListGraphCard/CurationListGraphCard";
import GrapeListGraphCard from "../components/Dashboard/GrapListGraphCard/GrapeListGraphCard";
import PlayoffListGraphCard from "../components/Dashboard/GrapListGraphCard/PlayoffListGraphCard";
import UserListGraphCard from "../components/Dashboard/GrapListGraphCard/UserListGraphCard";

export const Dashboard = ({ theme }) => {
	return (
		<>
			<Box>
				<Grid container spacing={4}>
					<Grid item xs={6}>
						<GrapeListGraphCard
							title="Product View Count "
							fetchDataFunc={getProductViewCount}
							type="playoff"
							id=""
						></GrapeListGraphCard>
					</Grid>
					<Grid item xs={6}>
						<GrapeListGraphCard
							title="Product View Count (Most Popular)"
							fetchDataFunc={getCommunityFavouritesGraph}
							id={2294}
							type="persistent_list"
						></GrapeListGraphCard>
					</Grid>
					<Grid item xs={6}>
						<GrapeListGraphCard
							title="Product View Count (Curated Deals)"
							fetchDataFunc={getCommunityFavouritesGraph}
							id={2295}
							type="persistent_list"
						></GrapeListGraphCard>
					</Grid>
					<Grid item xs={6}>
						<GrapeListGraphCard
							title="Product View Count (GrapeList)"
							fetchDataFunc={getGrapeListGraph}
							type="grape_list"
							id=""
						></GrapeListGraphCard>
					</Grid>

					<Grid item xs={6}>
						<UserListGraphCard
							title="User Share Count "
							fetchDataFunc={getUserShareGraph}
							type="grape_list"
							id=""
						></UserListGraphCard>
					</Grid>
					<Grid item xs={6}>
						<PlayoffListGraphCard
							title="Playoff Share Count "
							fetchDataFunc={getPlayoffShareGraph}
							type="grape_list"
							id=""
						></PlayoffListGraphCard>
					</Grid>
					<Grid item xs={6}>
						<CurationListGraphCard
							title="Curation Share Count "
							fetchDataFunc={getCurationShareGraph}
							type="grape_list"
							id=""
						></CurationListGraphCard>
					</Grid>
				</Grid>
			</Box>
		</>
	);
};
